import type { MantineColor } from "@mantine/core";

import AppSettings from "src/AppSettings";
import { NoticeSeverityType } from "src/api/Tmd.dtos";
import type { AppIconDefinition } from "src/components/common/Icon";

export interface NoticeSeverityPresentation {
    color: MantineColor;
    icon: AppIconDefinition;
    label: string;
}

const severities: Record<NoticeSeverityType, NoticeSeverityPresentation> = {
    [NoticeSeverityType.Default]: {
        color: "gray",
        icon: AppSettings.icons.models.notice,
        label: "Default"
    },
    [NoticeSeverityType.Information]: {
        color: "information",
        icon: AppSettings.icons.information,
        label: "Information"
    },
    [NoticeSeverityType.Warning]: {
        color: "warning",
        icon: AppSettings.icons.error.warning,
        label: "Warning"
    },
    [NoticeSeverityType.Error]: {
        color: "error",
        icon: AppSettings.icons.error.medium,
        label: "Error"
    },
    [NoticeSeverityType.Success]: {
        color: "success",
        icon: AppSettings.icons.success,
        label: "Success"
    }
};

/**
 * Returns the shared color, icon and label for the requested notice severity.
 * Postconditions: Nullish or unrecognized values fall back to the Default presentation.
 * Assumptions: Callers treat the returned shared object as read-only.
 */
export const getNoticeSeverityPresentation = (
    severity?: NoticeSeverityType
): NoticeSeverityPresentation =>
    severities[severity ?? NoticeSeverityType.Default] ?? severities[NoticeSeverityType.Default];
